import { Button, Screen, Text } from "components"
import React, { useState } from "react"
import { StatusBar, TouchableOpacity, View } from "react-native"
import { style } from "./styles"
import { Controller, useForm } from "react-hook-form"
import { translate } from "i18n"
import { useNavigation } from "@react-navigation/native"
import { typography } from "theme"
import flash from "config/flash"
import Icon from "@expo/vector-icons/Feather"
import { useColor } from "app/theme/getThemes"
import { observer } from "mobx-react-lite"
import { PhoneNumberInput } from "components/PhoneNumberInput"
import { useStores } from "models"

export const ForgetPinScreen = observer(() => {
  const navigation = useNavigation<any>()
  const { userStore } = useStores()
  const { flagInfo, setFlagInfo } = userStore
  const [isLoading, setIsLoading] = useState(false)
  const { companyTheme } = useColor()
  const [initialDefaultCountry, setInitialDefaultCountry] = useState(null)
  const [countryCode, setCountryCode] = useState("")
  const { control, handleSubmit, clearErrors } = useForm({
    reValidateMode: "onSubmit",
  })

  const onSubmit = async (data) => {
    const phoneNum = countryCode + data?.phoneNumber
    const phoneNumLast = phoneNum.replace(/\s/g, "")

    const formattedPhone = phoneNumLast.startsWith("+") ? phoneNumLast?.slice(1) : phoneNumLast

    setIsLoading(true)
    await fetch(`${process.env.API_URL}/api/client/otp/${formattedPhone}`, {
      method: "POST",
      body: JSON.stringify({
        company_code: process.env.COMPANY_CODE,
        configure_name: "whatsapp",
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        setIsLoading(false)
        if (res?.ok) {
          navigation.navigate("verification", {
            routeFrom: "forgetPin",
            phoneNumber: formattedPhone,
          })
        } else {
          const errorMsg = await data?.json()
          if (errorMsg?.error === "INVALID_MOBILENO") {
            flash("error", translate("errors.noAccount"))
          } else {
            flash("error", translate("forgetPinScreen.failedToVerify"))
          }
        }
      })
      .catch(() => {
        setIsLoading(false)
        flash("error", translate("forgetPinScreen.failedToVerify"))
      })
  }
  return (
    <Screen>
      <View style={[style.container, { marginTop: StatusBar.currentHeight + 10 }]}>
        <View style={{ flexDirection: "row", alignItems: "center", marginTop: 5 }}>
          <TouchableOpacity
            style={{
              backgroundColor: companyTheme.first,
              borderRadius: 8,
              paddingHorizontal: 25,
              paddingVertical: 5,
            }}
            onPress={() => navigation.goBack()}
          >
            <Icon name="chevron-left" size={25} color="white" />
          </TouchableOpacity>
        </View>
        <View>
          <View style={style.mt30}>
            <Text style={style.titleText}>{translate("forgetPinScreen.getStarted")}</Text>
            <Text style={{ fontFamily: typography.primary.normal }}>
              {translate("forgetPinScreen.description")}
            </Text>
          </View>
          <Controller
            name="phoneNumber"
            control={control}
            rules={{
              required: translate("errors.required"),
            }}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
              return (
                <Controller
                  name="phoneNumber"
                  control={control}
                  rules={{
                    required: translate("errors.required"),
                  }}
                  render={({ field: { onChange, value }, fieldState: { error } }) => {
                    return (
                      <PhoneNumberInput
                        value={value || ""}
                        defaultCountry={flagInfo.cca2}
                        onChange={(formattedPhoneNumber) => {
                          onChange(formattedPhoneNumber)
                        }}
                        onCustomFocus={() => clearErrors("phoneNumber")}
                        fieldError={error}
                        errorMessage={error?.message}
                        placeholder={translate("loginScreen.phoneNumberPlaceholder")}
                        title={
                          <Text>
                            {translate("loginScreen.phoneNumber")}
                            <Text style={{ color: "red" }}></Text>
                          </Text>
                        }
                        containerStyle={style.inputContainer}
                        inputStyle={style.inputStyle}
                        onCountryChange={(country) => {
                          if (country) {
                            setCountryCode(country.callingCode)
                            console.log("Selected Country Code:", country.callingCode)
                          }
                        }}
                      />
                    )
                  }}
                />
              )
            }}
          />
        </View>
        <View style={style.buttonContainer}>
          <Button
            loading={isLoading}
            onPress={handleSubmit(onSubmit)}
            style={style.loginButton}
            title={translate("common.verify")}
          />
        </View>
      </View>
    </Screen>
  )
})
